import { Progress } from "antd";

function ProgressBar() {
  return (
    <Progress
      type="line"
      percent={100}
      status="active"
      showInfo={false}
      strokeWidth={25}
      style={{ fontSize: "24px", marginTop: 20 }}
    />
  );
}

export default ProgressBar;
